import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface AuthUser {
  id: string;
  email: string;
  fullName: string;
  tenantId: string;
  roles: string[];
  permissions: string[];
}

interface AuthState {
  user: AuthUser | null;
  accessToken: string | null;
  refreshToken: string | null;
  setAuth: (user: AuthUser, accessToken: string, refreshToken: string) => void;
  setTokens: (accessToken: string, refreshToken: string) => void;
  setPermissions: (roles: string[], permissions: string[]) => void;
  clear: () => void;
  hasPermission: (code: string) => boolean;
  hasRole: (code: string) => boolean;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      user: null,
      accessToken: null,
      refreshToken: null,
      setAuth: (user, accessToken, refreshToken) => set({ user, accessToken, refreshToken }),
      setTokens: (accessToken, refreshToken) => set({ accessToken, refreshToken }),
      setPermissions: (roles, permissions) => {
        const cur = get().user;
        if (cur) set({ user: { ...cur, roles, permissions } });
      },
      clear: () => set({ user: null, accessToken: null, refreshToken: null }),
      hasPermission: (code) => {
        const perms = get().user?.permissions ?? [];
        return perms.includes('*') || perms.includes(code);
      },
      hasRole: (code) => {
        const roles = get().user?.roles ?? [];
        return roles.includes(code);
      },
    }),
    { name: 'omniretail-auth' }
  )
);
